import { Pipe, PipeTransform } from '@angular/core';
import { LssDeploymentEntity } from '../store/deployment.datamodel';

/**
 * Pipe to determine if the exclusion of a given entity should be disabled.
 */
@Pipe({
    name: 'isExclusionDisabled',
    standalone: false
})
export class IsExclusionDisabledPipe implements PipeTransform {

  transform(entity: LssDeploymentEntity): boolean {
    if (entity.deployedParent && entity.excludedParent) {
      return entity.excludedParent.depth > entity.deployedParent.depth;
    }
    if (!entity.deployedParent && !entity.excludedParent) {
      return !entity.isExcluded;
    }
    return entity.excludedParent !== undefined || entity.deployedParent === undefined;
  }

}

